import { render } from "./Divider.vue?vue&type=template&id=4d125024"
import script from "./Divider.vue?vue&type=script&lang=js"
export * from "./Divider.vue?vue&type=script&lang=js"

import "./Divider.vue?vue&type=style&index=0&id=4d125024&lang=scss"
script.render = render

export default script